import { Link, useLocation } from "react-router-dom";
import { Clapperboard, Film, Plus } from "lucide-react";

export const Header = () => {
  const { pathname } = useLocation();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#090B0E]/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5 group">
          <Clapperboard className="w-6 h-6 text-amber-500 group-hover:rotate-[-8deg] transition-transform" />
          <span className="font-display font-black text-lg tracking-tight text-white">
            Ciné<span className="text-amber-400">Grok</span> Studio
          </span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          <Link
            to="/films"
            data-testid="nav-projects-link"
            className={`flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              pathname === "/films" ? "bg-white/10 text-amber-400" : "text-slate-300 hover:text-white hover:bg-white/5"
            }`}
          >
            <Film className="w-4 h-4" />
            <span className="hidden sm:inline">Mes Films</span>
          </Link>
          <Link
            to="/"
            data-testid="nav-new-film-link"
            className="flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg text-sm font-bold bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-slate-950 transition-all active:scale-[0.98]"
          >
            <Plus className="w-4 h-4" />
            <span className="hidden sm:inline">Nouveau Film</span>
          </Link>
        </nav>
      </div>
    </header>
  );
};
